document.addEventListener("DOMContentLoaded", function () {
  // Function to check percentage of element out of viewport
  function percentageOutOfViewport(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;
    const visibleHeight =
      Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    return ((rect.height - visibleHeight) / rect.height) * 100;
  }

  // Get element and its computed styles
  const slideshowHero = document.querySelector(".slideshow-hero");
  if (slideshowHero) {
    const computedStyle = getComputedStyle(slideshowHero);
    let initialWidthOffset = parseFloat(
      computedStyle.getPropertyValue("--slideshow-width-offset")
    );

    // Check percentage of the section out of the viewport
    window.addEventListener("scroll", function () {
      const percentage = percentageOutOfViewport(slideshowHero);

      if (percentage >= 1 && percentage <= 50) {
        // Calculating how much of the initial width offset should be reduced
        let scale = Math.abs(percentage - 50) / (50 - 1);
        const newWidth = initialWidthOffset * scale;

        // Updating the width
        slideshowHero.style.width = `calc(100vw - ${newWidth}rem)`;

        // Setting border-radius to 0
        // slideshowHero.style.borderRadius = '0';
      } else if (percentage > 50) {
        slideshowHero.style.width = "100vw";
        // slideshowHero.style.borderRadius = '0';
      } else {
        // Reset to initial width and border-radius
        slideshowHero.style.width = `calc(100vw - ${initialWidthOffset}rem)`;
        // slideshowHero.style.borderRadius = ''; // Reset to original value
      }
    });
  }


  // Get element and its computed styles
  const slideshowHeroNew = document.querySelector(".custom-logo-slider-wrapper");
  if (slideshowHero) {
    const computedStyle = getComputedStyle(slideshowHero);
    let initialWidthOffset = parseFloat(
      computedStyle.getPropertyValue("--slideshow-width-offset")
    );

    // Check percentage of the section out of the viewport
    window.addEventListener("scroll", function () {
      const percentage = percentageOutOfViewport(slideshowHero);

      if (percentage >= 1 && percentage <= 50) {
        // Calculating how much of the initial width offset should be reduced
        let scale = Math.abs(percentage - 50) / (50 - 1);
        const newWidth = initialWidthOffset * scale;

        // Updating the width
        slideshowHeroNew.style.width = `calc(100vw - ${newWidth}rem)`;

        // Setting border-radius to 0
        // slideshowHero.style.borderRadius = '0';
      } else if (percentage > 50) {
        slideshowHeroNew.style.width = "100vw";
        // slideshowHero.style.borderRadius = '0';
      } else {
        // Reset to initial width and border-radius
        slideshowHeroNew.style.width = `calc(100vw - ${initialWidthOffset}rem)`;
        // slideshowHero.style.borderRadius = ''; // Reset to original value
      }
    });
  }

  // cart drawer animations

  // Select all elements with the attribute data-item="parent"
  const parentItems = document.querySelectorAll('[data-item="collapse"]');

  parentItems.forEach((parentItem) => {
    parentItem.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent the default action if needed
      const parentLi = parentItem.closest(".drawer-menu__item--emphasized");
      const subNav = parentLi.querySelector(".subnav");
      const svgElement = parentLi.querySelector(".menu-item__svg");

      if (subNav.style.maxHeight && subNav.style.maxHeight !== "0px") {
        // Close the subNav
        subNav.style.maxHeight = "0px";
        // Remove active class from SVG
        svgElement.classList.remove("active");
        subNav.classList.remove("active");
      } else {
        // Open the subNav
        const amountToAdd = subNav.scrollHeight + 10;
        subNav.style.maxHeight = amountToAdd + "px";
        // Add active class to SVG
        svgElement.classList.add("active");
        subNav.classList.add("active");
      }
    });
  });

  // set hero class to body element

  // Get the main element by its ID
  var mainElement = document.getElementById("main");

  // Ensure mainElement exists and has children to prevent errors
  if (mainElement && mainElement.children.length > 0) {
    var firstSection = mainElement.children[0];

    // Check if the first section has a child with the classes 'slideshow' and 'slideshow-hero'
    if (firstSection.querySelector(".slideshow.slideshow-hero")) {
      // If it does, add the 'data-enable-transparent-hero' attribute to the body element
      document.body.setAttribute("data-enable-transparent-hero", "true");
    } else {
      document.body.setAttribute("data-enable-transparent-hero", "false");
    }
  }
  // Modal animation
  function initModals() {
    // Get all modal triggers, modals, and the product modal wrapper
    const modalTriggers = document.querySelectorAll(".modal-trigger");
    const modals = document.querySelectorAll(".modal-container");
    const productModals = document.querySelector(".product__modals"); // The wrapper for product modals
    const htmlElement = document.documentElement; // The HTML element to toggle 'no-scrolling' class

    // Function to add 'no-scrolling' class to HTML
    const disableScrolling = () => {
      htmlElement.classList.add("no-scrolling");
    };

    // Function to remove 'no-scrolling' class from HTML
    const enableScrolling = () => {
      if (!document.querySelector(".modal-container.active")) {
        // Only enable scrolling if there are no active modals
        htmlElement.classList.remove("no-scrolling");
      }
    };

    // Function to close all modals and remove event listeners for overlay and body clicks
    const closeAllModals = () => {
      modals.forEach((modal) => {
        modal.classList.remove("active");
      });
      if (productModals) {
        productModals.classList.remove("active"); // Remove the 'active' class from the product modal wrapper
      }
      enableScrolling(); // Enable scrolling when all modals are closed

      // Remove event listeners for overlay and body clicks
      document.removeEventListener("click", handleOutsideClick);
      const overlay = document.querySelector(".quick-search__overlay");
      if (overlay) {
        overlay.removeEventListener("click", closeAllModals);
      }
    };

    // Function to handle clicks outside the modal
    const handleOutsideClick = (e) => {
      const isModalContent = e.target.closest(".modal-container");
      if (!isModalContent) {
        closeAllModals();
      }
    };

    // Function to show a specific modal
    const showModal = (modalId) => {
      const modal = document.querySelector(`[data-custom-modal="${modalId}"]`);
      if (modal) {
        modal.classList.add("active");
        disableScrolling(); // Disable scrolling when a modal is active

        if (productModals) {
          productModals.classList.add("active"); // Add the 'active' class to the product modal wrapper
        }

        // Add event listeners for overlay and body clicks
        document.addEventListener("click", handleOutsideClick);
        const overlay = document.querySelector(".quick-search__overlay");
        if (overlay) {
          overlay.addEventListener("click", closeAllModals);
        }
      }
    };

    // Function to handle trigger click
    const handleTriggerClick = (trigger) => {
      const modalId = trigger.getAttribute("data-modal-trigger");
      closeAllModals();
      showModal(modalId);
    };

    // Function to initialize event listeners
    const initEventListeners = () => {
      // Attach click event listeners to modal triggers
      modalTriggers.forEach((trigger) => {
        trigger.addEventListener("click", (event) => {
          event.stopPropagation(); // Prevent click from propagating to the document
          handleTriggerClick(trigger);
        });
      });

      // Attach click event listeners to close buttons
      modals.forEach((modal) => {
        const closeButton = modal.querySelector(".modal-close");
        if (closeButton) {
          closeButton.addEventListener("click", (event) => {
            event.stopPropagation(); // Prevent click from propagating to the document
            closeAllModals();
          });
        }
      });
    };

    // Initialize event listeners
    initEventListeners();
  }

  // Initialize modals
  initModals();

  //menu  and submenu items
  function setupSubmenuListeners() {
    const menuItems = document.querySelectorAll("[data-submenu-parent]");
    const delay = 300; // Delay in milliseconds
    let timeoutId;

    menuItems.forEach((item) => {
      const submenu = item.querySelector(".nav-item__submenu");

      // Handle mouse enter
      item.addEventListener("mouseenter", function () {
        clearTimeout(timeoutId); // Clear any pending submenu closures

        // Close all other submenus
        document
          .querySelectorAll(".nav-item__submenu")
          .forEach((otherSubmenu) => {
            if (otherSubmenu !== submenu) {
              otherSubmenu.classList.remove("active");
              otherSubmenu.style.maxHeight = null;
            }
          });

        // Open the hovered submenu
        if (submenu) {
          submenu.classList.add("active");
          submenu.style.maxHeight = submenu.scrollHeight + "px";
        }
      });

      // Handle mouse leave
      item.addEventListener("mouseleave", function () {
        // Set timeout to delay closing the submenu
        timeoutId = setTimeout(() => {
          if (submenu) {
            submenu.classList.remove("active");
            submenu.style.maxHeight = null;
          }
        }, delay);
      });
    });
  }
  setupSubmenuListeners();

  function setupSubmenumenuListeners() {
    const menuItems = document.querySelectorAll("[data-submenu-menu-parent]");
    const delay = 300;
    let timeoutId;

    menuItems.forEach((item) => {
      const submenu = item.querySelector(".nav_submenu_item_submenu");

      item.addEventListener("mouseenter", function () {
        clearTimeout(timeoutId);

        document
          .querySelectorAll(".nav_submenu_item_submenu")
          .forEach((otherSubmenu) => {
            if (otherSubmenu !== submenu) {
              otherSubmenu.classList.remove("active");
              otherSubmenu.style.maxHeight = null;
            }
          });

        if (submenu) {
          submenu.classList.add("active");
          submenu.style.maxHeight = submenu.scrollHeight + "px";
        }
      });

      item.addEventListener("mouseleave", function () {
        timeoutId = setTimeout(() => {
          if (submenu) {
            submenu.classList.remove("active");
            submenu.style.maxHeight = null;
          }
        }, delay);
      });
    });
  }

  setupSubmenumenuListeners();

  // This function sets an appropriate max-height for the transition to be smooth
  const setMaxHeight = (element) => {
    // Set max-height to the scrollHeight (actual content height)
    element.style.maxHeight = `${element.scrollHeight}px`;
  };

  // This function resets the max-height to ensure a smooth closing transition
  const resetMaxHeight = (element) => {
    // Set max-height back to 0 to start the close transition
    element.style.maxHeight = "0";
  };

  // This function toggles the accordion state
  const toggleAccordion = (container) => {
    const accordionText = container.querySelector(".accordion-text");
    const accordionSvg = container.querySelector(".accordion-svg");

    // Check if the accordion is currently open
    if (accordionText.classList.contains("open")) {
      // Close it
      resetMaxHeight(accordionText);
      accordionText.classList.remove("open");
      accordionSvg.classList.remove("rotated");
    } else {
      // Open it
      setMaxHeight(accordionText);
      accordionText.classList.add("open");
      accordionSvg.classList.add("rotated");
    }
  };

  // Attach the event listener to all containers
  const containers = document.querySelectorAll(".accordion__container");
  containers.forEach((container) => {
    container.addEventListener("click", () => toggleAccordion(container));
  });
});


$(document).ready(function(){
    $('.popupvideoenable').click(function(){
        var count = $(this).data('count');
        $('.mosaic-grid-popup-fill[data-count="' + count + '"]').addClass('activepopup');
        $('.overlay-mosaic[data-count="' + count + '"]').addClass('activepopup');
    });

    $('.mosaicbuttonclose').click(function(){
        $('.mosaic-grid-popup-fill').removeClass('activepopup');
        $('.overlay-mosaic').removeClass('activepopup');
        console.log("kjaskdjasd123");
    });

    $('.overlay-mosaic').click(function(){
        $(this).next('.mosaic-grid-popup-fill').removeClass('activepopup');
        $('.overlay-mosaic').removeClass('activepopup');
        console.log("kjaskdjasd222");
    });
});


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".custom_main_menu_header > div").forEach(function (menuItem) {
    menuItem.addEventListener("click", function () {
      let submenu = this.parentElement.querySelector(".custom_mobile_main_submenu");
      let icon = this.querySelector(".submenu-icon");
      let parentLi = this.parentElement;

      if (submenu) {
        let isVisible = submenu.style.display === "block";

        // Toggle display
        submenu.style.display = isVisible ? "none" : "block";

        // Toggle active class on the main menu item
        if (isVisible) {
          parentLi.classList.remove("active");
        } else {
          parentLi.classList.add("active");
        }

        // Rotate the SVG icon
        if (icon) {
          icon.style.transform = isVisible ? "rotate(0deg)" : "rotate(180deg)";
          icon.style.transition = "transform 0.3s ease";
        }
      }
    });
  });
});




// _____________ //

document.addEventListener("DOMContentLoaded", function() {
  const drawer = document.querySelector('.drawer-menu');

  function preventScroll(e) {
    if (!drawer.contains(e.target)) {
      e.preventDefault();
    }
  }

  function lockScroll() {
    document.documentElement.classList.add('no-scroll');
    document.body.classList.add('no-scroll');
    document.addEventListener('touchmove', preventScroll, { passive: false });
  }

  function unlockScroll() {
    document.documentElement.classList.remove('no-scroll');
    document.body.classList.remove('no-scroll');
    document.removeEventListener('touchmove', preventScroll);
  }

  // 🔍 Detect class changes
  const observer = new MutationObserver(() => {
    if (drawer.classList.contains('active')) {
      lockScroll();
    } else {
      unlockScroll();
    }
  });

  observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
});


var UpsellProductCardApp = (() => {
  var openCart = (element) => {
    element.classList.remove('loading');
    const cartIcon = document.querySelector('[data-js-cart-icon]');
    if (cartIcon) cartIcon.click();
  }
  
  var addUpsellProduct = (element) => {
    if (!element || !element.hasAttribute('data-variant-id')) return;
    
    const variant_id = element.getAttribute('data-variant-id');
    element.classList.add('loading');
    
    // Store function reference
    const handleCartUpdate = () => {
      openCart(element);
      document.removeEventListener('cart:updated', handleCartUpdate);
    };
    
    document.addEventListener('cart:updated', handleCartUpdate);
    window.addItemById(variant_id, 1);
  }
  
  var initialize = () => {
    document.querySelectorAll('[js-upsell-atc]').forEach(element => {
      element.addEventListener('click', () => {
        addUpsellProduct(element);
      });
    });
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      console.log('Items:', cart.items);
      Array.from(cart.items).forEach(item => {
        if (item.properties['__main_product']) {
          document.querySelectorAll(`[js-pdp-upsell-product][data-parent-product-id="${item.product_id}"]`).forEach(element => {
            element.classList.remove('d-none');
          });
        }
      });
    });
    document.addEventListener('cart:updated', (event) => {
      const cart = event.detail.cart;
      document.querySelectorAll(`[js-pdp-upsell-product][data-parent-product-id]`).forEach(element => {
        element.classList.add('d-none');
      });
      Array.from(cart.items).forEach(item => {
        if (item.properties['__main_product']) {
          document.querySelectorAll(`[js-pdp-upsell-product][data-parent-product-id="${item.product_id}"]`).forEach(element => {
            element.classList.remove('d-none');
          });
        }
      });
    });
  }
  
  return {
    init: initialize
  }
})();

var HeaderMenuApp = (() => {
  var closeLinkContent = (element) => {
    if (!element) return;
    element.classList.remove('open');
  }
  var openLinkContent = (container, link_content_attr) => {
    if (!container) return;
    container.querySelectorAll('[js-link-content], [js-desktop-link-content]').forEach(element => {
      closeLinkContent(element);
      if (element.getAttribute('js-link-content') === link_content_attr || element.getAttribute('js-desktop-link-content') === link_content_attr) {
        element.classList.add('open');
      }
    });
  }
  var initialize = () => {
    document.querySelectorAll('[data-drawer-menu] [js-link-trigger]').forEach(element => {
      element.addEventListener('click', () => {
        openLinkContent(element.closest('[data-drawer-menu]'), element.getAttribute('js-link-trigger'));
      });
    });
    document.querySelectorAll('[data-drawer-menu] [js-link-content] [js-back]').forEach(element => {
      element.addEventListener('click', () => {
        closeLinkContent(element.closest('[js-link-content]'));
      });
    });
    document.querySelectorAll('header [js-desktop-link-trigger]').forEach(element => {
      element.addEventListener('click', () => {
        openLinkContent(element.closest('header'), element.getAttribute('js-desktop-link-trigger'));
      });
      element.addEventListener('mouseover', () => {
        console.log('Here is mouseover event');
        openLinkContent(element.closest('header'), element.getAttribute('js-desktop-link-trigger'));
      });
    });
    document.querySelectorAll('header').forEach(container => {
      container.addEventListener('mouseleave', () => {
        container.querySelectorAll('[js-desktop-link-content]').forEach(element => {
          closeLinkContent(element);
        });
      });
      container.addEventListener('focusout', () => {
        container.querySelectorAll('[js-desktop-link-content]').forEach(element => {
          closeLinkContent(element);
        });
      });
    });
  }
  return {
    init: initialize
  }
})();

var FabrikatorNativeDisplayApp = (() => {
  const SHIPMENT_SELECTOR = ".fabrikator__shipment-text";
  const INJECTED_SELECTOR = ".bd-inventory-date-display";
  const PLACEHOLDER_PATTERN = /\{DATE_WILL_BE_SHOWN_HERE\}/i;

  let fabrikatorObserver = null;
  let bodyWaitObserver = null;
  let pollInterval = null;
  let debounceTimer = null;
  let isVariantListenerBound = false;

  function getShipmentTextEl() {
    return document.querySelector(SHIPMENT_SELECTOR);
  }

  function getInventoryDate() {
    const shipmentText = getShipmentTextEl();
    if (!shipmentText) return null;

    const span = shipmentText.querySelector("span");
    const text = (span?.textContent || shipmentText.textContent || "").trim();

    if (!text || PLACEHOLDER_PATTERN.test(text) || /[{}]/.test(text)) {
      return null;
    }

    return text;
  }

  function updatePreorderButtonLabel() {
    if (!getInventoryDate()) return;

    const atcButton = document.querySelector(
      ".custom-form-button .product-form__cart-submit"
    );
    if (atcButton) atcButton.textContent = "Vorbestellung";
  }

  function removeInjectedDateDisplay() {
    document.querySelectorAll(INJECTED_SELECTOR).forEach((el) => el.remove());
  }

  function unhideElement(el) {
    if (!el?.style) return;
    const inlineStyle = el.getAttribute("style") || "";
    if (el.style.display === "none" || /display\s*:\s*none/i.test(inlineStyle)) {
      el.style.removeProperty("display");
    }
  }

  function resetFabrikatorReadyState() {
    document
      .querySelectorAll(".shopify-app-block.fabrikator--ready")
      .forEach((block) => block.classList.remove("fabrikator--ready"));
  }

  function hideVariantsMetafields(appBlock) {
    appBlock
      ?.querySelectorAll(".fabrikator__variants-metafields")
      .forEach((el) => {
        el.style.setProperty("display", "none", "important");
      });
  }

  function showNativeFabrikatorBlock() {
    const shipmentText = getShipmentTextEl();
    if (!shipmentText || !getInventoryDate()) return;

    const appBlock = shipmentText.closest(".shopify-app-block");
    if (!appBlock) return;

    appBlock.classList.add("fabrikator--ready");
    hideVariantsMetafields(appBlock);

    let el = shipmentText;
    while (el && el !== appBlock.parentElement) {
      unhideElement(el);
      el = el.parentElement;
    }
  }

  function run() {
    removeInjectedDateDisplay();

    const appBlock = getShipmentTextEl()?.closest(".shopify-app-block");
    if (appBlock) hideVariantsMetafields(appBlock);

    showNativeFabrikatorBlock();
    updatePreorderButtonLabel();
  }

  function debouncedRun() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(run, 150);
  }

  function onVariantChange() {
    resetFabrikatorReadyState();
    debouncedRun();
  }

  function teardownFabrikatorObserver() {
    fabrikatorObserver?.disconnect();
    fabrikatorObserver = null;
  }

  function setupFabrikatorWatchers() {
    const shipmentText = getShipmentTextEl();
    if (!shipmentText) return false;

    const appBlock = shipmentText.closest(".shopify-app-block");
    if (!appBlock) return false;

    teardownFabrikatorObserver();
    run();

    fabrikatorObserver = new MutationObserver(debouncedRun);
    fabrikatorObserver.observe(appBlock, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"],
      characterData: true
    });

    if (!isVariantListenerBound) {
      document.addEventListener("product:variant-change", onVariantChange);
      isVariantListenerBound = true;
    }

    return true;
  }

  function waitForFabrikatorBlock() {
    if (setupFabrikatorWatchers()) {
      bodyWaitObserver?.disconnect();
      bodyWaitObserver = null;
      return;
    }

    if (!bodyWaitObserver) {
      bodyWaitObserver = new MutationObserver(() => {
        if (setupFabrikatorWatchers()) {
          bodyWaitObserver?.disconnect();
          bodyWaitObserver = null;
        }
      });
      bodyWaitObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  var initialize = () => {
    if (!window.location.pathname.includes("/products/")) return;

    waitForFabrikatorBlock();

    if (pollInterval) clearInterval(pollInterval);
    let attempts = 0;

    pollInterval = setInterval(() => {
      attempts += 1;
      waitForFabrikatorBlock();
      run();

      if ((getInventoryDate() && getShipmentTextEl()) || attempts >= 100) {
        clearInterval(pollInterval);
        pollInterval = null;
      }
    }, 300);

    setTimeout(() => {
      if (pollInterval) {
        clearInterval(pollInterval);
        pollInterval = null;
      }
      bodyWaitObserver?.disconnect();
      bodyWaitObserver = null;
    }, 30000);
  };

  return {
    init: initialize
  };
})();

var App = (() => {
  var initialize = () => {
    UpsellProductCardApp.init();
    HeaderMenuApp.init();
    FabrikatorNativeDisplayApp.init();
  }
  return {
    init: initialize
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  App.init();
});
 